var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"6","height":"1","viewBox":"0 0 6 1","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 1V0H6V1H0Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }